import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Inset } from 'syf-component-library/ui/spacing';
import { useTranslation } from 'react-i18next';
import triggerPaymentSecurityAnalytics from '../../../../../helpers/trigger-payment-security-analytics';
import { PAGE_NAME } from '../../../../../const/analytics';
import Content from '../../../../common/content';
import PaymentSecurityInfo from '../../../../common/payment-security-info';
import { ScreenWrapper } from '../subcomponents';
import Separator from './subcomponents';
import PaymentSecurityDebtCancellation from '../../../../common/payment-debt-cancellation';
import PaymentSecurityHeader from '../../header';
import AgreementCheckbox from '../../../../common/agreement-checkbox';
import SectionDetail from '../../../../common/section-detail';
const NotEnrolled = () => {
    const { t } = useTranslation();
    useEffect(() => {
        triggerPaymentSecurityAnalytics({
            pageName: PAGE_NAME.START
        });
    }, []);
    return (_jsxs(ScreenWrapper, { children: [_jsx(PaymentSecurityHeader, { title: t('notEnrolled.header.title'), subtitle: t('common.header.subtitle') }), _jsx(Inset, { horizontal: "large", children: _jsxs(Content, { children: [_jsx(Separator, {}), _jsx(SectionDetail, { title: t('notEnrolled.whatToKnow.title'), primaryDescription: _jsx(PaymentSecurityInfo, {}) }), _jsx(PaymentSecurityDebtCancellation, {}), _jsx(AgreementCheckbox, {})] }) })] }));
};
export default NotEnrolled;
